export default __webpack_public_path__ + "static/media/login.413b03f5.png";